import UploadZipDocumentRequestModelBase from '../_generated/modelBases/upload-zip-document-request-model-base';

export default class UploadZipDocumentRequestModel extends UploadZipDocumentRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
